import WebFooter from "../../../components/website/webFooter/WebFooter";
import WebHeader from "../../../components/website/webHeader/WebHeader";

export default function Features() {
  return (
    <>
      <WebHeader />
      <div className="page active" id="page-features">
        <section className="page-hero">
          <div className="hero-bg" />
          <div className="wrap">
            <span className="eyebrow">
              <span className="dot" />
              Features
            </span>
            <h1>
              Built for the way PGs
              <br />
              and rentals actually run.
            </h1>
            <p>
              Every module is the product of 300+ conversations with PG owners,
              landlords, and property managers — not a feature checklist copied
              from a US SaaS.
            </p>
          </div>
        </section>
        {/* Feature 1: PG Management */}
        <section className="feat-section">
          <div className="wrap">
            <div className="feat-row">
              <div>
                <span className="eyebrow" style={{ marginBottom: 20 }}>
                  <span className="dot" />
                  PG Management
                </span>
                <h2>Bed-level, not room-level.</h2>
                <p className="lead">
                  Most property software treats a room as a unit. We treat every
                  bed as one. Because a "triple-sharing" room with one vacant
                  bed is not the same as a vacant room.
                </p>
                <div className="feat-list">
                  <div className="feat-list-item">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <div>
                      <strong>Individual tenant per bed</strong>
                      <span>
                        Assign rent, food plan, deposit, and KYC at the bed
                        level, not shared across roommates.
                      </span>
                    </div>
                  </div>
                  <div className="feat-list-item">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <div>
                      <strong>Drag-to-reassign</strong>
                      <span>
                        Someone vacates 203-A, another wants to move in from 210
                        — drag the card. History auto-reconciles.
                      </span>
                    </div>
                  </div>
                  <div className="feat-list-item">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <div>
                      <strong>Color-coded status</strong>
                      <span>
                        Occupied, due, overdue, notice-filed, vacant,
                        under-maintenance — know it at a glance.
                      </span>
                    </div>
                  </div>
                  <div className="feat-list-item">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <div>
                      <strong>Floor &amp; wing hierarchy</strong>
                      <span>
                        Group beds into rooms, rooms into floors, floors into
                        blocks, blocks into properties.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="feat-visual-lg">
                <svg
                  className="mock"
                  viewBox="0 0 560 420"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width={560} height={420} fill="#fff" rx={12} />
                  <rect
                    x={0}
                    y={0}
                    width={560}
                    height={40}
                    rx={12}
                    fill="#f5f5f3"
                  />
                  <text
                    x={20}
                    y={26}
                    fontFamily="Plus Jakarta Sans"
                    fontSize={13}
                    fontWeight={700}
                    fill="#1a1a18"
                  >
                    UrbanNest · Floor 2 · 24 beds
                  </text>
                  <g
                    transform="translate(20,60)"
                    fontFamily="Plus Jakarta Sans"
                    fontSize={10}
                    fontWeight={600}
                    fill="#fff"
                  >
                    <rect
                      x={0}
                      y={0}
                      width={78}
                      height={58}
                      rx={8}
                      fill="#0F6E56"
                    />
                    <text x={39} y={22} textAnchor="middle">
                      201-A
                    </text>
                    <text
                      x={39}
                      y={38}
                      textAnchor="middle"
                      fontSize={9}
                      fill="rgba(255,255,255,0.8)"
                    >
                      Priya S.
                    </text>
                    <text
                      x={39}
                      y={50}
                      textAnchor="middle"
                      fontSize={8}
                      fill="rgba(255,255,255,0.7)"
                    >
                      Paid · Apr 3
                    </text>
                    <rect
                      x={86}
                      y={0}
                      width={78}
                      height={58}
                      rx={8}
                      fill="#0F6E56"
                    />
                    <text x={125} y={22} textAnchor="middle">
                      201-B
                    </text>
                    <text
                      x={125}
                      y={38}
                      textAnchor="middle"
                      fontSize={9}
                      fill="rgba(255,255,255,0.8)"
                    >
                      Nisha R.
                    </text>
                    <text
                      x={125}
                      y={50}
                      textAnchor="middle"
                      fontSize={8}
                      fill="rgba(255,255,255,0.7)"
                    >
                      Paid · Apr 1
                    </text>
                    <rect
                      x={172}
                      y={0}
                      width={78}
                      height={58}
                      rx={8}
                      fill="#0F6E56"
                    />
                    <text x={211} y={22} textAnchor="middle">
                      201-C
                    </text>
                    <text
                      x={211}
                      y={38}
                      textAnchor="middle"
                      fontSize={9}
                      fill="rgba(255,255,255,0.8)"
                    >
                      Kavya P.
                    </text>
                    <text
                      x={211}
                      y={50}
                      textAnchor="middle"
                      fontSize={8}
                      fill="rgba(255,255,255,0.7)"
                    >
                      Paid · Apr 4
                    </text>
                    <rect
                      x={258}
                      y={0}
                      width={78}
                      height={58}
                      rx={8}
                      fill="#BA7517"
                    />
                    <text x={297} y={22} textAnchor="middle">
                      202-A
                    </text>
                    <text
                      x={297}
                      y={38}
                      textAnchor="middle"
                      fontSize={9}
                      fill="rgba(255,255,255,0.85)"
                    >
                      Aarav J.
                    </text>
                    <text
                      x={297}
                      y={50}
                      textAnchor="middle"
                      fontSize={8}
                      fill="rgba(255,255,255,0.7)"
                    >
                      Due Apr 28
                    </text>
                    <rect
                      x={344}
                      y={0}
                      width={78}
                      height={58}
                      rx={8}
                      fill="#0F6E56"
                    />
                    <text x={383} y={22} textAnchor="middle">
                      202-B
                    </text>
                    <text
                      x={383}
                      y={38}
                      textAnchor="middle"
                      fontSize={9}
                      fill="rgba(255,255,255,0.8)"
                    >
                      Ishaan V.
                    </text>
                    <text
                      x={383}
                      y={50}
                      textAnchor="middle"
                      fontSize={8}
                      fill="rgba(255,255,255,0.7)"
                    >
                      Paid · Apr 2
                    </text>
                    <rect
                      x={430}
                      y={0}
                      width={78}
                      height={58}
                      rx={8}
                      fill="#A32D2D"
                    />
                    <text x={469} y={22} textAnchor="middle">
                      203-A
                    </text>
                    <text
                      x={469}
                      y={38}
                      textAnchor="middle"
                      fontSize={9}
                      fill="rgba(255,255,255,0.85)"
                    >
                      Sanya L.
                    </text>
                    <text
                      x={469}
                      y={50}
                      textAnchor="middle"
                      fontSize={8}
                      fill="rgba(255,255,255,0.7)"
                    >
                      8 days late
                    </text>
                    <rect
                      x={0}
                      y={66}
                      width={78}
                      height={58}
                      rx={8}
                      fill="#0F6E56"
                    />
                    <text x={39} y={88} textAnchor="middle">
                      203-B
                    </text>
                    <text
                      x={39}
                      y={104}
                      textAnchor="middle"
                      fontSize={9}
                      fill="rgba(255,255,255,0.8)"
                    >
                      Arjun M.
                    </text>
                    <text
                      x={39}
                      y={116}
                      textAnchor="middle"
                      fontSize={8}
                      fill="rgba(255,255,255,0.7)"
                    >
                      Notice filed
                    </text>
                    <rect
                      x={86}
                      y={66}
                      width={78}
                      height={58}
                      rx={8}
                      fill="#efefec"
                      stroke="rgba(0,0,0,0.12)"
                    />
                    <text x={125} y={88} textAnchor="middle" fill="#5f5e5a">
                      204-A
                    </text>
                    <text
                      x={125}
                      y={104}
                      textAnchor="middle"
                      fontSize={9}
                      fill="#888780"
                    >
                      Vacant
                    </text>
                    <text
                      x={125}
                      y={116}
                      textAnchor="middle"
                      fontSize={8}
                      fill="#888780"
                    >
                      Listed
                    </text>
                    <rect
                      x={172}
                      y={66}
                      width={78}
                      height={58}
                      rx={8}
                      fill="#0F6E56"
                    />
                    <text x={211} y={88} textAnchor="middle">
                      204-B
                    </text>
                    <text
                      x={211}
                      y={104}
                      textAnchor="middle"
                      fontSize={9}
                      fill="rgba(255,255,255,0.8)"
                    >
                      Rahul K.
                    </text>
                    <text
                      x={211}
                      y={116}
                      textAnchor="middle"
                      fontSize={8}
                      fill="rgba(255,255,255,0.7)"
                    >
                      Paid · Apr 5
                    </text>
                    <rect
                      x={258}
                      y={66}
                      width={78}
                      height={58}
                      rx={8}
                      fill="#0F6E56"
                    />
                    <text x={297} y={88} textAnchor="middle">
                      205-A
                    </text>
                    <text
                      x={297}
                      y={104}
                      textAnchor="middle"
                      fontSize={9}
                      fill="rgba(255,255,255,0.8)"
                    >
                      Neha G.
                    </text>
                    <text
                      x={297}
                      y={116}
                      textAnchor="middle"
                      fontSize={8}
                      fill="rgba(255,255,255,0.7)"
                    >
                      Paid · Apr 3
                    </text>
                    <rect
                      x={344}
                      y={66}
                      width={78}
                      height={58}
                      rx={8}
                      fill="#0F6E56"
                    />
                    <text x={383} y={88} textAnchor="middle">
                      205-B
                    </text>
                    <text
                      x={383}
                      y={104}
                      textAnchor="middle"
                      fontSize={9}
                      fill="rgba(255,255,255,0.8)"
                    >
                      Megha T.
                    </text>
                    <text
                      x={383}
                      y={116}
                      textAnchor="middle"
                      fontSize={8}
                      fill="rgba(255,255,255,0.7)"
                    >
                      Paid · Apr 2
                    </text>
                    <rect
                      x={430}
                      y={66}
                      width={78}
                      height={58}
                      rx={8}
                      fill="#534AB7"
                    />
                    <text x={469} y={88} textAnchor="middle">
                      206
                    </text>
                    <text
                      x={469}
                      y={104}
                      textAnchor="middle"
                      fontSize={9}
                      fill="rgba(255,255,255,0.85)"
                    >
                      Under reno
                    </text>
                    <text
                      x={469}
                      y={116}
                      textAnchor="middle"
                      fontSize={8}
                      fill="rgba(255,255,255,0.7)"
                    >
                      Back May 5
                    </text>
                    <rect
                      x={0}
                      y={132}
                      width={78}
                      height={58}
                      rx={8}
                      fill="#0F6E56"
                    />
                    <text x={39} y={154} textAnchor="middle">
                      207-A
                    </text>
                    <text
                      x={39}
                      y={170}
                      textAnchor="middle"
                      fontSize={9}
                      fill="rgba(255,255,255,0.8)"
                    >
                      Tara S.
                    </text>
                    <rect
                      x={86}
                      y={132}
                      width={78}
                      height={58}
                      rx={8}
                      fill="#0F6E56"
                    />
                    <text x={125} y={154} textAnchor="middle">
                      207-B
                    </text>
                    <text
                      x={125}
                      y={170}
                      textAnchor="middle"
                      fontSize={9}
                      fill="rgba(255,255,255,0.8)"
                    >
                      Alia K.
                    </text>
                    <rect
                      x={172}
                      y={132}
                      width={78}
                      height={58}
                      rx={8}
                      fill="#0F6E56"
                    />
                    <text x={211} y={154} textAnchor="middle">
                      208
                    </text>
                    <text
                      x={211}
                      y={170}
                      textAnchor="middle"
                      fontSize={9}
                      fill="rgba(255,255,255,0.8)"
                    >
                      Vikram K.
                    </text>
                    <rect
                      x={258}
                      y={132}
                      width={78}
                      height={58}
                      rx={8}
                      fill="#BA7517"
                    />
                    <text x={297} y={154} textAnchor="middle">
                      209-A
                    </text>
                    <text
                      x={297}
                      y={170}
                      textAnchor="middle"
                      fontSize={9}
                      fill="rgba(255,255,255,0.85)"
                    >
                      Due Apr 29
                    </text>
                    <rect
                      x={344}
                      y={132}
                      width={78}
                      height={58}
                      rx={8}
                      fill="#0F6E56"
                    />
                    <text x={383} y={154} textAnchor="middle">
                      209-B
                    </text>
                    <text
                      x={383}
                      y={170}
                      textAnchor="middle"
                      fontSize={9}
                      fill="rgba(255,255,255,0.8)"
                    >
                      Rohit D.
                    </text>
                    <rect
                      x={430}
                      y={132}
                      width={78}
                      height={58}
                      rx={8}
                      fill="#efefec"
                      stroke="rgba(0,0,0,0.12)"
                    />
                    <text x={469} y={154} textAnchor="middle" fill="#5f5e5a">
                      210
                    </text>
                    <text
                      x={469}
                      y={170}
                      textAnchor="middle"
                      fontSize={9}
                      fill="#888780"
                    >
                      Vacant
                    </text>
                  </g>
                  <g
                    transform="translate(20,280)"
                    fontFamily="Plus Jakarta Sans"
                    fontSize={10}
                    fill="#5f5e5a"
                  >
                    <rect
                      x={0}
                      y={0}
                      width={520}
                      height={120}
                      rx={10}
                      fill="#f5f5f3"
                    />
                    <text
                      x={14}
                      y={22}
                      fontWeight={700}
                      fill="#1a1a18"
                      fontSize={11}
                    >
                      LEGEND
                    </text>
                    <rect
                      x={14}
                      y={34}
                      width={10}
                      height={10}
                      rx={2}
                      fill="#0F6E56"
                    />
                    <text x={30} y={43}>
                      Occupied · paid
                    </text>
                    <rect
                      x={140}
                      y={34}
                      width={10}
                      height={10}
                      rx={2}
                      fill="#BA7517"
                    />
                    <text x={156} y={43}>
                      Due soon
                    </text>
                    <rect
                      x={240}
                      y={34}
                      width={10}
                      height={10}
                      rx={2}
                      fill="#A32D2D"
                    />
                    <text x={256} y={43}>
                      Overdue
                    </text>
                    <rect
                      x={340}
                      y={34}
                      width={10}
                      height={10}
                      rx={2}
                      fill="#534AB7"
                    />
                    <text x={356} y={43}>
                      Maintenance
                    </text>
                    <rect
                      x={14}
                      y={58}
                      width={10}
                      height={10}
                      rx={2}
                      fill="#efefec"
                      stroke="rgba(0,0,0,0.12)"
                    />
                    <text x={30} y={67}>
                      Vacant
                    </text>
                    <text
                      x={14}
                      y={94}
                      fill="#1a1a18"
                      fontWeight={700}
                      fontSize={11}
                    >
                      THIS FLOOR
                    </text>
                    <text x={14} y={110}>
                      Total 24 beds · 22 occupied · 2 vacant · 88.5% occupancy
                    </text>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </section>
        {/* Feature 2: Food */}
        <section
          className="feat-section"
          style={{ background: "var(--bg-soft)" }}
        >
          <div className="wrap">
            <div className="feat-row reverse">
              <div>
                <span className="eyebrow" style={{ marginBottom: 20 }}>
                  <span className="dot" />
                  Food Management
                </span>
                <h2>Your kitchen finally knows how much to cook.</h2>
                <p className="lead">
                  Weekly menus, dietary preferences, guest meals, and daily
                  counts — all auto-delivered to the kitchen every morning at
                  7am.
                </p>
                <div className="feat-list">
                  <div className="feat-list-item">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <div>
                      <strong>Plan once, serve forever</strong>
                      <span>
                        Build your weekly rotation of breakfast, lunch, and
                        dinner. Override a day when needed.
                      </span>
                    </div>
                  </div>
                  <div className="feat-list-item">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <div>
                      <strong>Veg / non-veg / Jain splits</strong>
                      <span>
                        Tenants pick their plan. System tracks per-meal counts,
                        not just headcount.
                      </span>
                    </div>
                  </div>
                  <div className="feat-list-item">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <div>
                      <strong>Guest meals &amp; skip notices</strong>
                      <span>
                        "Won't be in for dinner" / "One guest for lunch" —
                        auto-logged, auto-billed or auto-discounted.
                      </span>
                    </div>
                  </div>
                  <div className="feat-list-item">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <div>
                      <strong>Waste reports</strong>
                      <span>
                        See which days/meals over-prep the most. Average 15-22%
                        food cost reduction in month 1.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="feat-visual-lg">
                <svg
                  className="mock"
                  viewBox="0 0 560 380"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width={560} height={380} fill="#fff" rx={12} />
                  <rect
                    x={0}
                    y={0}
                    width={560}
                    height={40}
                    rx={12}
                    fill="#f5f5f3"
                  />
                  <text
                    x={20}
                    y={26}
                    fontFamily="Plus Jakarta Sans"
                    fontSize={13}
                    fontWeight={700}
                    fill="#1a1a18"
                  >
                    Kitchen count · Tuesday Apr 22
                  </text>
                  <g
                    transform="translate(20,60)"
                    fontFamily="Plus Jakarta Sans"
                  >
                    <rect
                      x={0}
                      y={0}
                      width={520}
                      height={86}
                      rx={10}
                      fill="#FAEEDA"
                    />
                    <text
                      x={16}
                      y={26}
                      fontWeight={700}
                      fill="#BA7517"
                      fontSize={12}
                      letterSpacing="0.04em"
                    >
                      BREAKFAST · 7:30–9:30 AM
                    </text>
                    <text
                      x={16}
                      y={50}
                      fontSize={18}
                      fontWeight={800}
                      fill="#1a1a18"
                    >
                      Upma + sambhar + banana
                    </text>
                    <g fontSize={13} fill="#5f5e5a">
                      <text x={16} y={72}>
                        Veg:{" "}
                        <tspan fill="#1a1a18" fontWeight={700}>
                          142
                        </tspan>
                      </text>
                      <text x={100} y={72}>
                        Non-veg:{" "}
                        <tspan fill="#1a1a18" fontWeight={700}>
                          42
                        </tspan>
                      </text>
                      <text x={200} y={72}>
                        Guests:{" "}
                        <tspan fill="#BA7517" fontWeight={700}>
                          +3
                        </tspan>
                      </text>
                      <text x={280} y={72}>
                        Fasting:{" "}
                        <tspan fill="#1a1a18" fontWeight={700}>
                          2
                        </tspan>
                      </text>
                      <text x={380} y={72}>
                        Total:{" "}
                        <tspan fill="#1a1a18" fontWeight={700}>
                          185
                        </tspan>
                      </text>
                    </g>
                  </g>
                  <g
                    transform="translate(20,164)"
                    fontFamily="Plus Jakarta Sans"
                  >
                    <rect
                      x={0}
                      y={0}
                      width={520}
                      height={86}
                      rx={10}
                      fill="#EAF3DE"
                    />
                    <text
                      x={16}
                      y={26}
                      fontWeight={700}
                      fill="#3B6D11"
                      fontSize={12}
                      letterSpacing="0.04em"
                    >
                      LUNCH · 12:30–2:30 PM
                    </text>
                    <text
                      x={16}
                      y={50}
                      fontSize={18}
                      fontWeight={800}
                      fill="#1a1a18"
                    >
                      Rajma rice + salad + papad
                    </text>
                    <g fontSize={13} fill="#5f5e5a">
                      <text x={16} y={72}>
                        Veg:{" "}
                        <tspan fill="#1a1a18" fontWeight={700}>
                          148
                        </tspan>
                      </text>
                      <text x={100} y={72}>
                        Non-veg:{" "}
                        <tspan fill="#1a1a18" fontWeight={700}>
                          42
                        </tspan>
                      </text>
                      <text x={200} y={72}>
                        Guests:{" "}
                        <tspan fill="#BA7517" fontWeight={700}>
                          +1
                        </tspan>
                      </text>
                      <text x={280} y={72}>
                        Skip:{" "}
                        <tspan fill="#A32D2D" fontWeight={700}>
                          6
                        </tspan>
                      </text>
                      <text x={380} y={72}>
                        Total:{" "}
                        <tspan fill="#1a1a18" fontWeight={700}>
                          185
                        </tspan>
                      </text>
                    </g>
                  </g>
                  <g
                    transform="translate(20,268)"
                    fontFamily="Plus Jakarta Sans"
                  >
                    <rect
                      x={0}
                      y={0}
                      width={520}
                      height={86}
                      rx={10}
                      fill="#E6F1FB"
                    />
                    <text
                      x={16}
                      y={26}
                      fontWeight={700}
                      fill="#185FA5"
                      fontSize={12}
                      letterSpacing="0.04em"
                    >
                      DINNER · 8:00–10:00 PM
                    </text>
                    <text
                      x={16}
                      y={50}
                      fontSize={18}
                      fontWeight={800}
                      fill="#1a1a18"
                    >
                      Pav bhaji + onion rings
                    </text>
                    <g fontSize={13} fill="#5f5e5a">
                      <text x={16} y={72}>
                        Veg:{" "}
                        <tspan fill="#1a1a18" fontWeight={700}>
                          170
                        </tspan>
                      </text>
                      <text x={100} y={72}>
                        Non-veg:{" "}
                        <tspan fill="#1a1a18" fontWeight={700}>
                          0
                        </tspan>
                      </text>
                      <text x={200} y={72}>
                        Guests:{" "}
                        <tspan fill="#BA7517" fontWeight={700}>
                          +2
                        </tspan>
                      </text>
                      <text x={280} y={72}>
                        Skip:{" "}
                        <tspan fill="#A32D2D" fontWeight={700}>
                          12
                        </tspan>
                      </text>
                      <text x={380} y={72}>
                        Total:{" "}
                        <tspan fill="#1a1a18" fontWeight={700}>
                          172
                        </tspan>
                      </text>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </section>
        {/* Feature 3: Tickets */}
        <section className="feat-section">
          <div className="wrap">
            <div className="feat-row">
              <div>
                <span className="eyebrow" style={{ marginBottom: 20 }}>
                  <span className="dot" />
                  Support Tickets
                </span>
                <h2>Voice or text — whichever your tenant prefers.</h2>
                <p className="lead">
                  Working professionals type. Students voice-note. Older tenants
                  call. MyRentMitra handles all three, and turns them into
                  structured tickets you can actually resolve.
                </p>
                <div className="feat-list">
                  <div className="feat-list-item">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <div>
                      <strong>Voice → text transcription</strong>
                      <span>
                        AI transcribes 42-second voice notes in 10 languages.
                        Original audio saved too.
                      </span>
                    </div>
                  </div>
                  <div className="feat-list-item">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <div>
                      <strong>Auto-categorization</strong>
                      <span>
                        AC, plumbing, Wi-Fi, food, housekeeping — auto-tagged
                        and routed to the right staff.
                      </span>
                    </div>
                  </div>
                  <div className="feat-list-item">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <div>
                      <strong>SLA tracking</strong>
                      <span>
                        Set target resolution times. See what's slipping. Alert
                        staff before tenants get angry.
                      </span>
                    </div>
                  </div>
                  <div className="feat-list-item">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <div>
                      <strong>Tenant ratings</strong>
                      <span>
                        Post-resolution 5-star rating by tenant. Track staff
                        performance with honest data.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="feat-visual-lg">
                <svg
                  className="mock"
                  viewBox="0 0 560 420"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width={560} height={420} fill="#fff" rx={12} />
                  <g
                    transform="translate(20,20)"
                    fontFamily="Plus Jakarta Sans"
                  >
                    <rect
                      x={0}
                      y={0}
                      width={520}
                      height={88}
                      rx={10}
                      fill="#FCEBEB"
                      stroke="rgba(163,45,45,0.2)"
                    />
                    <rect
                      x={16}
                      y={16}
                      width={60}
                      height={20}
                      rx={4}
                      fill="#A32D2D"
                    />
                    <text
                      x={46}
                      y={30}
                      textAnchor="middle"
                      fontSize={10}
                      fontWeight={700}
                      fill="#fff"
                    >
                      URGENT
                    </text>
                    <rect
                      x={82}
                      y={16}
                      width={64}
                      height={20}
                      rx={4}
                      fill="#534AB7"
                    />
                    <text
                      x={114}
                      y={30}
                      textAnchor="middle"
                      fontSize={10}
                      fontWeight={700}
                      fill="#fff"
                    >
                      🎙 VOICE
                    </text>
                    <text
                      x={16}
                      y={56}
                      fontSize={15}
                      fontWeight={700}
                      fill="#1a1a18"
                    >
                      "AC not working from morning"
                    </text>
                    <text x={16} y={74} fontSize={12} fill="#5f5e5a">
                      Rahul K · Room 204-B · 0:42 audio · transcribed from Hindi
                    </text>
                  </g>
                  <g
                    transform="translate(20,124)"
                    fontFamily="Plus Jakarta Sans"
                  >
                    <rect
                      x={0}
                      y={0}
                      width={520}
                      height={80}
                      rx={10}
                      fill="#f5f5f3"
                    />
                    <text
                      x={16}
                      y={26}
                      fontSize={11}
                      fontWeight={700}
                      fill="#5f5e5a"
                      letterSpacing="0.05em"
                    >
                      AUTO-DETECTED
                    </text>
                    <g transform="translate(16,38)">
                      <rect
                        x={0}
                        y={0}
                        width={80}
                        height={24}
                        rx={5}
                        fill="#fff"
                        stroke="rgba(0,0,0,0.1)"
                      />
                      <text
                        x={40}
                        y={16}
                        textAnchor="middle"
                        fontSize={11}
                        fill="#1a1a18"
                        fontWeight={600}
                      >
                        Category
                      </text>
                      <rect
                        x={88}
                        y={0}
                        width={100}
                        height={24}
                        rx={5}
                        fill="#E6F1FB"
                      />
                      <text
                        x={138}
                        y={16}
                        textAnchor="middle"
                        fontSize={11}
                        fill="#185FA5"
                        fontWeight={700}
                      >
                        HVAC / AC
                      </text>
                      <rect
                        x={200}
                        y={0}
                        width={80}
                        height={24}
                        rx={5}
                        fill="#fff"
                        stroke="rgba(0,0,0,0.1)"
                      />
                      <text
                        x={240}
                        y={16}
                        textAnchor="middle"
                        fontSize={11}
                        fill="#1a1a18"
                        fontWeight={600}
                      >
                        Priority
                      </text>
                      <rect
                        x={288}
                        y={0}
                        width={70}
                        height={24}
                        rx={5}
                        fill="#FCEBEB"
                      />
                      <text
                        x={323}
                        y={16}
                        textAnchor="middle"
                        fontSize={11}
                        fill="#A32D2D"
                        fontWeight={700}
                      >
                        High
                      </text>
                      <rect
                        x={370}
                        y={0}
                        width={80}
                        height={24}
                        rx={5}
                        fill="#fff"
                        stroke="rgba(0,0,0,0.1)"
                      />
                      <text
                        x={410}
                        y={16}
                        textAnchor="middle"
                        fontSize={11}
                        fill="#1a1a18"
                        fontWeight={600}
                      >
                        SLA
                      </text>
                      <rect
                        x={458}
                        y={0}
                        width={54}
                        height={24}
                        rx={5}
                        fill="#EAF3DE"
                      />
                      <text
                        x={485}
                        y={16}
                        textAnchor="middle"
                        fontSize={11}
                        fill="#3B6D11"
                        fontWeight={700}
                      >
                        4 hrs
                      </text>
                    </g>
                  </g>
                  <g
                    transform="translate(20,220)"
                    fontFamily="Plus Jakarta Sans"
                  >
                    <text
                      x={0}
                      y={18}
                      fontSize={12}
                      fontWeight={700}
                      fill="#5f5e5a"
                      letterSpacing="0.05em"
                    >
                      RESOLUTION TIMELINE
                    </text>
                    <circle cx={12} cy={48} r={5} fill="#0F6E56" />
                    <line
                      x1={12}
                      y1={54}
                      x2={12}
                      y2={86}
                      stroke="rgba(0,0,0,0.1)"
                      strokeDasharray="2 3"
                    />
                    <text
                      x={28}
                      y={52}
                      fontSize={12}
                      fontWeight={600}
                      fill="#1a1a18"
                    >
                      Ticket auto-created
                    </text>
                    <text x={400} y={52} fontSize={11} fill="#888780">
                      09:42 AM
                    </text>
                    <circle cx={12} cy={90} r={5} fill="#0F6E56" />
                    <line
                      x1={12}
                      y1={96}
                      x2={12}
                      y2={128}
                      stroke="rgba(0,0,0,0.1)"
                      strokeDasharray="2 3"
                    />
                    <text
                      x={28}
                      y={94}
                      fontSize={12}
                      fontWeight={600}
                      fill="#1a1a18"
                    >
                      Assigned to Suresh (AC tech)
                    </text>
                    <text x={400} y={94} fontSize={11} fill="#888780">
                      09:44 AM
                    </text>
                    <circle cx={12} cy={132} r={5} fill="#0F6E56" />
                    <line
                      x1={12}
                      y1={138}
                      x2={12}
                      y2={170}
                      stroke="rgba(0,0,0,0.1)"
                      strokeDasharray="2 3"
                    />
                    <text
                      x={28}
                      y={136}
                      fontSize={12}
                      fontWeight={600}
                      fill="#1a1a18"
                    >
                      Tenant notified · ETA 11 AM
                    </text>
                    <text x={400} y={136} fontSize={11} fill="#888780">
                      09:45 AM
                    </text>
                    <circle cx={12} cy={174} r={5} fill="#BA7517" />
                    <text
                      x={28}
                      y={178}
                      fontSize={12}
                      fontWeight={600}
                      fill="#1a1a18"
                    >
                      In progress · gas refill needed
                    </text>
                    <text x={400} y={178} fontSize={11} fill="#888780">
                      11:12 AM
                    </text>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </section>
        {/* Feature 4: Billing */}
        <section
          className="feat-section"
          style={{ background: "var(--bg-soft)" }}
        >
          <div className="wrap">
            <div className="feat-row reverse">
              <div>
                <span className="eyebrow" style={{ marginBottom: 20 }}>
                  <span className="dot" />
                  Billing &amp; Payments
                </span>
                <h2>Rent that collects itself.</h2>
                <p className="lead">
                  Set the rent, the due date, the late-fee policy once. The
                  system invoices, reminds, collects, reconciles, and receipts —
                  forever.
                </p>
                <div className="feat-list">
                  <div className="feat-list-item">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <div>
                      <strong>UPI-first, zero fees</strong>
                      <span>
                        Direct NPCI rates. No gateway markup on Starter &amp;
                        Growth plans.
                      </span>
                    </div>
                  </div>
                  <div className="feat-list-item">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <div>
                      <strong>Split rent by components</strong>
                      <span>
                        Rent + food + utilities + maintenance — tenant sees the
                        breakdown, you see the margin.
                      </span>
                    </div>
                  </div>
                  <div className="feat-list-item">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <div>
                      <strong>Adhoc charges &amp; adjustments</strong>
                      <span>
                        Electricity top-up, damage deduction, one-time services
                        — add on the fly.
                      </span>
                    </div>
                  </div>
                  <div className="feat-list-item">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <div>
                      <strong>Tally / Zoho Books sync</strong>
                      <span>
                        Push collected rent straight to your accounting
                        software. No double entry.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="feat-visual-lg">
                <svg
                  className="mock"
                  viewBox="0 0 560 380"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width={560} height={380} fill="#fff" rx={12} />
                  <g
                    transform="translate(20,20)"
                    fontFamily="Plus Jakarta Sans"
                  >
                    <rect
                      x={0}
                      y={0}
                      width={520}
                      height={60}
                      rx={10}
                      fill="#f5f5f3"
                    />
                    <text
                      x={16}
                      y={24}
                      fontSize={11}
                      fontWeight={700}
                      fill="#888780"
                      letterSpacing="0.04em"
                    >
                      INVOICE
                    </text>
                    <text
                      x={16}
                      y={46}
                      fontFamily="JetBrains Mono"
                      fontSize={14}
                      fontWeight={600}
                      fill="#1a1a18"
                    >
                      NM-1284 · Priya Sharma · Apr 2025
                    </text>
                    <rect
                      x={436}
                      y={18}
                      width={70}
                      height={28}
                      rx={6}
                      fill="#EAF3DE"
                    />
                    <text
                      x={471}
                      y={36}
                      textAnchor="middle"
                      fontSize={11}
                      fontWeight={700}
                      fill="#3B6D11"
                    >
                      PAID
                    </text>
                  </g>
                  <g
                    transform="translate(20,96)"
                    fontFamily="Plus Jakarta Sans"
                    fontSize={13}
                  >
                    <text x={0} y={16} fill="#5f5e5a">
                      Rent (Bed 203-B, single occupancy)
                    </text>
                    <text
                      x={520}
                      y={16}
                      textAnchor="end"
                      fill="#1a1a18"
                      fontWeight={600}
                    >
                      ₹9,500.00
                    </text>
                    <line
                      x1={0}
                      y1={28}
                      x2={520}
                      y2={28}
                      stroke="rgba(0,0,0,0.06)"
                    />
                    <text x={0} y={48} fill="#5f5e5a">
                      Food plan · veg · full month
                    </text>
                    <text
                      x={520}
                      y={48}
                      textAnchor="end"
                      fill="#1a1a18"
                      fontWeight={600}
                    >
                      ₹2,500.00
                    </text>
                    <line
                      x1={0}
                      y1={60}
                      x2={520}
                      y2={60}
                      stroke="rgba(0,0,0,0.06)"
                    />
                    <text x={0} y={80} fill="#5f5e5a">
                      Utilities (electricity, Wi-Fi, cleaning)
                    </text>
                    <text
                      x={520}
                      y={80}
                      textAnchor="end"
                      fill="#1a1a18"
                      fontWeight={600}
                    >
                      ₹500.00
                    </text>
                    <line
                      x1={0}
                      y1={92}
                      x2={520}
                      y2={92}
                      stroke="rgba(0,0,0,0.06)"
                    />
                    <text x={0} y={112} fill="#5f5e5a">
                      Guest meal (Apr 14)
                    </text>
                    <text
                      x={520}
                      y={112}
                      textAnchor="end"
                      fill="#1a1a18"
                      fontWeight={600}
                    >
                      ₹150.00
                    </text>
                    <line
                      x1={0}
                      y1={124}
                      x2={520}
                      y2={124}
                      stroke="rgba(0,0,0,0.06)"
                    />
                    <text x={0} y={144} fill="#3B6D11">
                      Early payment discount (−2%)
                    </text>
                    <text
                      x={520}
                      y={144}
                      textAnchor="end"
                      fill="#3B6D11"
                      fontWeight={600}
                    >
                      − ₹253.00
                    </text>
                  </g>
                  <g
                    transform="translate(20,256)"
                    fontFamily="Plus Jakarta Sans"
                  >
                    <rect
                      x={0}
                      y={0}
                      width={520}
                      height={52}
                      rx={8}
                      fill="#1a1a18"
                    />
                    <text
                      x={16}
                      y={32}
                      fontSize={14}
                      fontWeight={700}
                      fill="#fff"
                    >
                      Total paid
                    </text>
                    <text
                      x={504}
                      y={34}
                      textAnchor="end"
                      fontSize={20}
                      fontWeight={800}
                      fill="#fff"
                    >
                      ₹12,397.00
                    </text>
                  </g>
                  <g
                    transform="translate(20,322)"
                    fontFamily="Plus Jakarta Sans"
                    fontSize={11}
                    fill="#888780"
                  >
                    <text x={0} y={14}>
                      Paid via UPI · rohit@oksbi · Transaction ID: 410394823942
                      · Apr 3, 9:42 AM
                    </text>
                    <text x={0} y={32}>
                      Auto-synced to Tally · Journal entry #TL-4892 · Apr 3,
                      9:43 AM
                    </text>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </section>
        {/* Feature 5: Analytics */}
        <section className="feat-section">
          <div className="wrap">
            <div className="feat-row">
              <div>
                <span className="eyebrow" style={{ marginBottom: 20 }}>
                  <span className="dot" />
                  Analytics
                </span>
                <h2>Know which property is actually making money.</h2>
                <p className="lead">
                  Occupancy, revenue-per-bed, churn, collection velocity —
                  across one property or fifty. With plain-English explanations,
                  not just charts.
                </p>
                <div className="feat-list">
                  <div className="feat-list-item">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <div>
                      <strong>Cross-property dashboards</strong>
                      <span>
                        Compare UrbanNest vs ShelterCo vs StayHQ on the metrics
                        that matter.
                      </span>
                    </div>
                  </div>
                  <div className="feat-list-item">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <div>
                      <strong>Churn cohort analysis</strong>
                      <span>
                        See which months lose tenants, which sharing types
                        stick, which rent tiers retain.
                      </span>
                    </div>
                  </div>
                  <div className="feat-list-item">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <div>
                      <strong>AI-generated insights</strong>
                      <span>
                        "Floor 3 is 92% occupied but has 3× complaint volume.
                        Check staffing." — actual insights.
                      </span>
                    </div>
                  </div>
                  <div className="feat-list-item">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <div>
                      <strong>Export to Excel / PDF</strong>
                      <span>
                        Monthly P&amp;L, occupancy reports, TDS summaries — one
                        click.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="feat-visual-lg">
                <svg
                  className="mock"
                  viewBox="0 0 560 380"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <defs>
                    <linearGradient id="ag1" x1={0} y1={0} x2={0} y2={1}>
                      <stop offset={0} stopColor="#0F6E56" stopOpacity="0.35" />
                      <stop offset={1} stopColor="#0F6E56" stopOpacity={0} />
                    </linearGradient>
                  </defs>
                  <rect width={560} height={380} fill="#fff" rx={12} />
                  <g
                    transform="translate(20,20)"
                    fontFamily="Plus Jakarta Sans"
                  >
                    <text
                      x={0}
                      y={16}
                      fontSize={11}
                      fontWeight={700}
                      fill="#888780"
                      letterSpacing="0.04em"
                    >
                      REVENUE PER BED · LAST 6 MONTHS
                    </text>
                    <text
                      x={0}
                      y={46}
                      fontSize={26}
                      fontWeight={800}
                      fill="#1a1a18"
                    >
                      ₹14,820
                    </text>
                    <text
                      x={140}
                      y={46}
                      fontSize={12}
                      fill="#3B6D11"
                      fontWeight={700}
                    >
                      ▲ 8.4% vs last period
                    </text>
                    <g transform="translate(0,72)">
                      <polygon
                        points="0,108 80,94 160,88 240,72 320,60 400,48 480,32 480,120 0,120"
                        fill="url(#ag1)"
                      />
                      <polyline
                        points="0,108 80,94 160,88 240,72 320,60 400,48 480,32"
                        fill="none"
                        stroke="#0F6E56"
                        strokeWidth="2.5"
                      />
                      <circle cx={480} cy={32} r={5} fill="#0F6E56" />
                      <circle
                        cx={480}
                        cy={32}
                        r={10}
                        fill="#0F6E56"
                        fillOpacity="0.15"
                      />
                    </g>
                    <g fontSize={10} fill="#888780">
                      <text x={0} y={210}>
                        Nov
                      </text>
                      <text x={80} y={210}>
                        Dec
                      </text>
                      <text x={160} y={210}>
                        Jan
                      </text>
                      <text x={240} y={210}>
                        Feb
                      </text>
                      <text x={320} y={210}>
                        Mar
                      </text>
                      <text x={400} y={210}>
                        Apr
                      </text>
                    </g>
                  </g>
                  <g
                    transform="translate(20,248)"
                    fontFamily="Plus Jakarta Sans"
                  >
                    <rect
                      x={0}
                      y={0}
                      width={520}
                      height={112}
                      rx={10}
                      fill="#f5f5f3"
                    />
                    <text
                      x={16}
                      y={24}
                      fontSize={11}
                      fontWeight={700}
                      fill="#534AB7"
                      letterSpacing="0.04em"
                    >
                      ● AI INSIGHT
                    </text>
                    <text
                      x={16}
                      y={48}
                      fontSize={14}
                      fontWeight={700}
                      fill="#1a1a18"
                    >
                      Your single-occupancy beds earn 34% more
                    </text>
                    <text x={16} y={72} fontSize={12} fill="#5f5e5a">
                      Revenue per single bed: ₹18,200 · Triple-sharing: ₹13,600.
                    </text>
                    <text x={16} y={88} fontSize={12} fill="#5f5e5a">
                      Consider converting 4 triple rooms to single/double on
                      Floor 3.
                    </text>
                    <text
                      x={16}
                      y={104}
                      fontSize={11}
                      fill="#185FA5"
                      fontWeight={600}
                    >
                      See breakdown →
                    </text>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </section>
      </div>

      <WebFooter />
    </>
  );
}
